import React, { useState } from "react";
import { Button } from "web/react/emo/button";
import { View } from "web/react/emo/view";
import { getBuyOptionStickerType } from "web/react/pages/product/in-stock/in-stock-product-page/utils";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import { BuyOptionSerializer } from "web/types/serializers";
import { TableHeader } from "./header/product-comparison-table-header";
import * as styles from "./product-comparison-table.css";
import { TableRow } from "./row/product-comparison-table-row";

export function PriceComparisonTable({
    buyOptions,
    sortedBuyOptionsKeys,
    termsUrl,
}: {
    buyOptions: BuyOptionSerializer[];
    sortedBuyOptionsKeys: string[];
    termsUrl: string;
}): JSX.Element {
    // If more then 5 buyOptions we only show the first 5
    const displayedBuyOptionsLimit = 5;
    const [displayedBuyOptionsKeys, setDisplayedBuyOptionsKeys] = useState(
        sortedBuyOptionsKeys.slice(0, displayedBuyOptionsLimit)
    );
    // count of the not displayed buyOptions
    const notDisplayedBuyOptionsCount = sortedBuyOptionsKeys.length - displayedBuyOptionsLimit;

    function onClick(): void {
        setDisplayedBuyOptionsKeys(sortedBuyOptionsKeys);
        analytics.event("see-more-prices", "clicked", "pdp");
    }

    return (
        <div>
            <View className={styles.comparisonWrapper}>
                <TableHeader />
                {displayedBuyOptionsKeys.map((linkId) => {
                    const buyOption = buyOptions[linkId];
                    // first buyOption is cheapest (displayedBuyOptionsKeys[0])
                    const stickerType = getBuyOptionStickerType(
                        buyOption,
                        displayedBuyOptionsKeys[0]
                    );

                    return (
                        <TableRow
                            buyOption={buyOption}
                            key={linkId}
                            stickerType={stickerType}
                            termsUrl={termsUrl}
                        />
                    );
                })}
            </View>
            {displayedBuyOptionsKeys.length < sortedBuyOptionsKeys.length && (
                <div className={styles.seeMoreButton}>
                    <Button
                        title={
                            // "See more {count} prices"
                            gettext("in_stock_product.compare_prices.see_more_prices_cta", {
                                count: notDisplayedBuyOptionsCount,
                            })
                        }
                        onClick={onClick}
                        variant="secondary"
                    />
                </div>
            )}
        </div>
    );
}
